module.exports = __webpack_public_path__ + "assets/img/IMG027.1db66df7.png";